<div class="wrapper">
   <h2 style="text-align:center;">{{'CERTIFICAR.FORALL.SELECCIONE' | translate}}</h2>
    <div>
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>{{'CERTIFICAR.FORALL.PLACEHOLDER' | translate}}</mat-label>
        <mat-select #selectSector
        (selectionChange)="changeIdioma($event);">
           <mat-option *ngFor="let idioma of idiomasArray; let i = index;"
           [value]="idioma">

                    {{'CERTIFICAR.FORALL.IDIOMAS.'+idioma.nombreIdioma | translate}}
            </mat-option>
        </mat-select>
        <mat-icon matSuffix class="secondary-text">language</mat-icon>
        <mat-error>sector is _required</mat-error>
    </mat-form-field>
    </div>

    <div class="pt-24 pb-16" fxLayout="row" fxLayoutAlign="center center" *ngIf="questions.length == 0">
        <mat-icon class="m-0 mr-16 secondary-text">error_outline</mat-icon>
        <div class="h2 secondary-text">{{'CERTIFICAR.ADICIONALES.PREVIEW.SINPREV' | translate}}</div>
    </div>

    <div cdkDropList class="movie-list" (cdkDropListDropped)="drop($event)" *ngIf="questions.length > 0">

      <div class="movie-block" *ngFor="let question of questions" cdkDrag >
          <label id="example-radio-group-label">{{ question.preguntaTraduccion }} </label><br>
          <mat-radio-group
            aria-labelledby="example-radio-group-label"
            class="example-radio-group"
            [(ngModel)]="responses">
            <mat-radio-button *ngFor="let opcion of question.opciones"  class="example-radio-button" disabled>{{ opcion.traduccionOpcion }}</mat-radio-button>

          </mat-radio-group>

      </div>
    </div>
</div>
